module.exports = __webpack_public_path__ + "static/media/success.c1034c55.svg";